<div class="redirect-page-wrapper">
    <div class="redirect-page-inner">
        <div class="redirect-page-logo">
            <img
                src="assets/demo/images/champ.png"
                alt="Champions logo"
                class="mb-4 w-6rem flex-shrink-0"
            />
        </div>
        <div class="redirect-page-content mt-2">
            <span class="message-text mb-2">Click on the button below to check your payment status</span>
            <div class="flex align-items-center my-4 justify-content-center w-full">
                <button (click)="fetchStatus()" pButton>Refresh payment status</button>
            </div>
            <p *ngIf="loading">Loading...</p>
            <p-dialog [(visible)]="showResultDialog" [closable]="false" header="Payment Result">

                <div class="redirect-content-title">
                    <i class="pi pi-exclamation-circle"></i>
                    <p>{{ status }}</p>
                </div>
                <div class="divider"></div>
                <span>{{ message }}</span>
            </p-dialog>

        </div>
    </div>
</div>
